import {
  ISalePageDetailV2ResponseProduct,
  SalePageSaleStatus,
} from '@/api/types';
import { DateTime } from '@/types';

export interface GachaTicketButtonProps {
  state: 'active' | 'disabled';
  label: string;
  subLabel?: string;
  onClick?: () => void;
  plannedStartAt?: DateTime;
}

type NonOnSaleStatus = Exclude<SalePageSaleStatus, 'ON_SALE'>;

export const getGachaCtaForStatus = (
  status: NonOnSaleStatus,
  ctx: { startAt?: DateTime }
): GachaTicketButtonProps => {
  switch (status) {
    case 'PLANNED':
      return {
        state: 'disabled',
        label: '오픈 예정',
        plannedStartAt: ctx.startAt,
      };
    case 'ENDED':
      return { state: 'disabled', label: '판매 종료' };
    case 'STOPPED':
      return { state: 'disabled', label: '판매 중지' };
    case 'SOLD_OUT':
      return { state: 'disabled', label: '품절' };
  }
};

export const getGachaCtaForProduct = (
  product: ISalePageDetailV2ResponseProduct,
  onClick: (productId: number) => void
): GachaTicketButtonProps => {
  if (product.saleStatus === 'ON_SALE') {
    return {
      state: 'active',
      label: product.name,
      subLabel: `${product.price.amount.toLocaleString()}원`,
      onClick: () => onClick(product.id),
    };
  }
  return {
    state: 'disabled',
    label: product.name,
    subLabel: '소진됨',
  };
};
